import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { inject } from "@vercel/analytics";

// Global error handler to capture mobile TDZ errors
window.addEventListener("error", (event) => {
  console.error("[GLOBAL_ERROR]", event.message, event.filename, event.lineno, event.colno, event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("[UNHANDLED_REJECTION]", event.reason);
});

createRoot(document.getElementById("root")!).render(<App />);

// Initialize Vercel Analytics
inject();
